import { render, staticRenderFns } from "./CategoryModalEdit.vue?vue&type=template&id=0b48c54e&scoped=true"
import script from "./CategoryModalEdit.vue?vue&type=script&lang=js"
export * from "./CategoryModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48c54e",
  null
  
)

export default component.exports